export const ticketColumns = [
  ['actions', 'Thao tác'], ['cartId', 'Mã đơn'], ['id', 'Mã vé'],
  ['user', 'Người chơi'], ['game', 'Trò chơi / Kỳ quay'], ['completedPeriod', 'Kỳ hoàn thành'],
  ['value', 'Giá trị'], ['images', 'Hình ảnh'], ['status', 'Trạng thái'],
  ['refund', 'Hoàn tiền'], ['createdAt', 'Ngày mua'], ['paidAt', 'Ngày thanh toán'],
  ['deletedAt', 'Ngày hủy'], ['printedAt', 'Ngày in'], ['doneAt', 'Ngày hoàn thành'], ['employee', 'Nhân viên'],
];
export const defaultColumns = ['actions', 'id', 'user', 'game', 'value', 'status', 'createdAt', 'employee'];
export const sortableColumns = ['cartId', 'id', 'user', 'value', 'createdAt'];

export function getTicketScope(query) {
  if (['keno', 'other'].includes(query.tab)) return query.tab;
  const game = query.gameId || (/^[a-z0-9]+-\d+$/i.test(query.gamePeriodId || '') ? query.gamePeriodId.split('-')[0] : '');
  if (game) return game === 'keno' ? 'keno' : 'other';
  // Resolve old exact-lookup links before restricting results to a tab.
  return query.ticketId || query.cartId || query.gamePeriodId ? null : 'keno';
}

export function loadTicketColumns(scope) {
  try {
    const saved = JSON.parse(localStorage.getItem(`ticket-columns:${scope}`));
    if (Array.isArray(saved)) return ['actions', ...ticketColumns.map(([id]) => id).filter(id => id !== 'actions' && saved.includes(id))];
  } catch (_) { /* Fall back when storage is unavailable or invalid. */ }
  return [...defaultColumns];
}
